import Cookies from 'js-cookie'

const TokenKey = 'operation-token'

export function sysGetToken() {
  const operateLoginInfo = JSON.parse(localStorage.getItem('operateLoginInfo')) || {}
  return operateLoginInfo.token || ''
}

export function sysSetToken(token) {
  return Cookies.set(TokenKey, token)
}

export function sysRemoveToken() {
  return Cookies.remove(TokenKey)
}



// WEBPACK FOOTER //
// ./src/utils/sys_auth.js